import PermissionsBase from "permissions/permissions_base";

class CommentsEditorPermissions extends PermissionsBase {
}

CommentsEditorPermissions.prototype.permissions = {
  _manageComments: true,
  _renderCloseCommentsButtonView: true,
  _renderCommentRecommendsView: true,
  _renderContentSubscriptionIndicatorView: true,
  _renderEditorControls: true,
  _renderModeratorControls: false,
  _renderNewCommentButtonView: true,
  _renderOpenCommentsButtonView: true,
  _renderReplyButton: true,
  _renderReportButton: true,
  _renderSignInToCommentButtonView: false,
};

export default CommentsEditorPermissions;
